import React, {useState, useEffect} from 'react'
import { BgLogoBlue, BgLogoWhite, BGLogoBlueAndBlack } from '../../images/index.js'
import SlideOver from '../landingPage/SlideOver.js';
import { Link } from 'react-router-dom';
import { MenuIcon} from '@heroicons/react/solid';
import { useHistory, useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import useApp from '../../store/app/appContext';
import ProfilePicture from '../../components/App/ProfilePicture.js';
import ChevronDown from '../../components/Icons/solid/ChevronDown';
import ChevronUp from '../../components/Icons/solid/ChevronUp';
import TemplateIcon from '../../components/Icons/outline/TemplateIcon.js';
import LogoutIcon from '../../components/Icons/outline/LogoutIcon';
import { COLORS } from '../../config';

function HeaderNavbar({menuIcon, logo, dark, aboutUs, patient, professional}) {

  const history = useHistory();
  const location = useLocation();
  const currentLocation = location.pathname;

  const [showSubmenu, setShowSubmenu] = useState(false);

  const toggleSubmenu = () => {
    setShowSubmenu(!showSubmenu);
  }

  const { logout, appState: { isAuthenticated, user } } = useApp();
 
  const [open, setOpen] = useState(false);
  
  function slideOver() {
    setOpen(!open)
  }
  const mainDiv = React.useRef(null);

  let listener = null
  const [scrolledTop, setScrolledTop] = useState(true)

  useEffect(() => {

    let height = (aboutUs ? 600 : 650);
    
    
    listener = document.addEventListener("scroll", e => {
      if(window.scrollY>(window.innerHeight-height)) {
        if(scrolledTop) setScrolledTop(false)
      } 

      if(window.scrollY<=(window.innerHeight-height)) {
        if(!scrolledTop) setScrolledTop(true) 
      }
    })
    return () => {
      document.removeEventListener("scroll", listener)
    }
  }, [scrolledTop])
  
  function RenderLogo() {
    switch (logo) {
      case "white": return <img alt='logo' src={BgLogoWhite} className="object-contain w-44"/>
      case "blue&white": return <img alt='logo' src={BgLogoBlue} className="object-contain w-44"/>
      case "blue&black": return <img alt='logo' src={BGLogoBlueAndBlack} className="object-contain w-44"/>
      default: return <img alt='logo' src={BgLogoWhite} className="object-contain w-44"/>
    }
  }

  const PATIENT = { 
    backgroundColor: `${patient && "rgba(84, 145, 183, .6)"}`
  }

  const PROFESSIONAL = {
    backgroundColor: `${professional && "rgba(84, 145, 183, .6)"}`
  }
  
  const bgColor = dark? "bg-bgDark" : "bg-white"  

  return (
    <div
      ref={mainDiv}
      className={`maindiv transition ease-in duration-200 flex justify-between w-screen h-16 md:h-20 px-6 md:px-12 lg:px-20 2xl:px-30 fixed py-3 z-50 ${
        !scrolledTop ? bgColor : `${bgColor} lg:bg-transparent`
      }`}
    >
      <SlideOver open={open} setOpen={setOpen}>
        <div className="flex flex-col mt-4">
          <Link
            to="/patient"
            className={`lg:py-4 py-2 mb-1 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md ${
              patient && "bg-primary text-white font-semibold"
            }`}
            style={PATIENT}
          >
            I am a patient
          </Link>
          <Link
            to="/professional"
            className={`lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md ${
              professional && "bg-primary text-white font-semibold"
            }`}
            style={PROFESSIONAL}
          >
            I am a professional
          </Link>
          {(professional || patient) && (
            <div
              className="self-center h-0.5 border border-grey-500 my-4 mx-auto"
              style={{ width: "95%" }}
            />
          )}
          {professional && (
            <>
              <a
                href={`/professional#Network`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                {/* <img src={OurNetwork} className="w-8 h-8"/> */}
                <span className="self-center">Our Network</span>
              </a>
              <a
                href={`/professional#GoDigital`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                {/* <img src={GoDigital} className="w-8 h-8"/> */}
                <span className="self-center">Go Digital with XiViX</span>
              </a>
              <a
                href={`/professional#Workflow`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                {/* <img src={OurWorkflow} className="w-8 h-8"/> */}
                <span className="self-center">Our Workflow</span>
              </a>
              <a
                href={`/professional#Partner`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                {/* <img src={XiViXPartners} className="w-8 h-8"/> */}
                <span className="self-center">XiViX Partners</span>
              </a>
              <a
                href={`/professional#Services`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                {/* <img src={OurServices} className="w-8 h-8"/> */}
                <span className="self-center">Our services</span>
              </a>
              <a
                href={`/professional#PartnerBenefits`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                {/* <img src={PartnersBenefits} className="w-8 h-8"/> */}
                <span className="self-center">Partner Benefits</span>
              </a>
              <a
                href={`/professional#MapComponent`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
    
                <span className="self-center">Contact us</span>
              </a>
            </>
          )}
          {patient && (
            <>
              <a
                href={`/patient#DigitalDentalDesign`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                <span className="self-center">Our network</span>
              </a>
              <a
                href={`/patient#ScanAndGo`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                <span className="self-center">Scan & Go</span>
              </a>
              <a
                href={`/patient#Services`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                <span className="self-center">Our Services</span>
              </a>
              <a
                href={`/patient#GoDigitalPat`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                {/* <img src={PatientJourney} className="w-8 h-8"/> */}
                <span className="self-center">
                  Digital Dentistry with XiViX
                </span>
              </a>
              <a
                href={`/patient#PatientBenefits`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                <span className="self-center">Patient Benefits</span>
              </a>
              <a
                href={`/patient#TreatmentPlans`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                <span className="self-center">Treatment Plans</span>
              </a>
              <a
                href={`/patient#MapComponent`}
                onClick={() => setOpen(false)}
                className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md flex gap-3"
              >
                <span className="self-center">Contact us</span>
              </a>
            </>
          )}
          {(professional || patient) && (
            <div
              className="mx-auto self-center h-0.5 border border-grey-500 my-4"
              style={{ width: "95%" }}
            />
          )}
          {patient ? (
            <Link
              to="/patient/about-us"
              className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md"
            >
              About us
            </Link>
          ) : (
            <Link
              to="/professional/about-us"
              className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md"
            >
              About us
            </Link>
          )}
          {patient ? (
            <Link
              to="/patient/careers"
              className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md"
            >
              Careers at XiViX
            </Link>
          ) : (
            <Link
              to="/professional/careers"
              className="lg:py-4 py-2 px-4 hover:bg-blue-50 hover:bg-opacity-60 rounded-md"
            >
              Careers at XiViX
            </Link>
          )}
          {!isAuthenticated ? (
            <button
              className={`text-primary border-primary-light bg-white hover:bg-blue-50 flex justify-center items-center  border rounded py-2 lg:py-3 px-2 mt-2 w-full`}
              onClick={() => history.push("/login")}
            >
              Login
            </button>
          ) : (
            <button
              className="text-primary border-primary-light flex justify-center items-center bg-white border rounded hover:bg-blue-50 py-2 lg:py-3 px-2 mt-2 w-full"
              onClick={() => history.push("/dashboard")}
            >
              My XiViX Platform
            </button>
          )}
        </div>
      </SlideOver>
      {RenderLogo()}
      <div className="flex justify-center">
        {!isAuthenticated ? (
          <button
            className={`${
              patient &&
              "text-primary border-primary-light bg-white hover:bg-blue-50"
            } ${
              professional &&
              "text-white border-white bg-transparent hover:bg-primary"
            } flex justify-center items-center  border rounded lg:my-3 px-2 w-20 lg:w-28 mr-4`}
            onClick={() => history.push("/login")}
          >
            Login
          </button>
        ) : (
          <div className="flex px-2 mr-4">
            <div className="my-auto mx-2">
              {!isMobile && (
                <h1
                  className={`text-xl cursor-pointer ${
                    patient ? "text-black" : "text-white"
                  }`}
                  onClick={() => toggleSubmenu()}
                >{`${user.first_name}`}</h1>
              )}
            </div>
            {!showSubmenu && (
              <ChevronDown
                fill={COLORS.colorSecondary}
                className="cursor-pointer my-auto"
                onClick={() => toggleSubmenu()}
              />
            )}
            {showSubmenu && (
              <ChevronUp
                fill={COLORS.colorPrimary}
                className="cursor-pointer my-auto"
                onClick={() => toggleSubmenu()}
              />
            )}
            {showSubmenu && (
              <div
                className={`absolute p-4 rounded shadow transform translate-y-14 -translate-x-16 mx-4 xl:ml-12 bg-white`}
              >
                <div
                  className={`flex items-center ${
                    currentLocation.includes("/account")
                      ? "text-primary"
                      : "text-secondary"
                  } hover:text-primary cursor-pointer`}
                  onClick={() => history.push("/dashboard")}
                >
                  <TemplateIcon
                    stroke={COLORS.colorPrimary}
                    className={"flex"}
                  />
                  <span className="ml-8">Dashboard</span>
                </div>
                <div
                  className={`flex items-center text-secondary hover:text-primary cursor-pointer`}
                  onClick={logout}
                >
                  <LogoutIcon stroke={COLORS.colorPrimary} />
                  <span className="ml-8">Logout</span>
                </div>
              </div>
            )}
            <div
              onClick={() => toggleSubmenu()}
              className="my-auto lg:mx-2 cursor-pointer"
            >
              <ProfilePicture small user={user} />
            </div>
          </div>
        )}
        <button onClick={slideOver}>
          <MenuIcon
            className={`w-8 h-8 md:h-10 md:w-10 ${
              menuIcon === "blue" ? "text-primary" : "text-white"
            }`}
          />
        </button>
      </div>
    </div>
  );
}

export default HeaderNavbar
